<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Kampagne löschen</span>
      </v-card-title>
      <v-card-text>
        Möchtest du die Kampagne "{{campaign.title}}" wirklich löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="loading"
          color="error"
          flat
          @click.native="remove()"
        >Löschen
        </v-btn>
        <v-btn
          color="blue darken-1"
          flat
          @click.native="dialog = false"
        >Abbrechen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'DlgCampaignDelete',
    props: {
      campaign: {
        type: Object,
        default: {},
      },
      value: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      dialog: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      ...mapActions({
        removeCampaign: 'campaigns/remove',
        readAll: 'campaigns/read',
      }),
      async remove() {
        this.loading = true;
        if (await this.removeCampaign(this.campaign)) {
          await this.readAll();
          this.dialog = false;
        }
        this.loading = false;
      },
    },
  };
</script>

<style scoped>

</style>
